




























































    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import TablePager from '@/components/TablePager.vue';
    import TableField from '@/types/TableField';
    import TableSortEventArgs from '@/types/TableSortEventArgs';
    import PagerOptions, { InitPagerOptions } from '@/types/PagerOptions';
    import SortOptions from '@/types/SortOptions';
    import EntityReference from '@/types/EntityReference';
    import { BTable, BButton, BIconArrowUp, BIconArrowDown, BSpinner } from 'bootstrap-vue';
    import ProjectFilterOptions from '@/types/ProjectFilterOptions';
    import Configuration from '@/types/Configuration';
    import InlineSvg from 'vue-inline-svg';
    import ColumnHeader from '@/components/ColumnHeader.vue';
    import AxiosService from '@/services/axiosService';
    import i18n from '../i18n';
    import Authorization, { PermissionScope } from '../types/Authorization';

    @Component({
        components: {
            'table-pager': TablePager,
            'b-table': BTable,
            'b-btn': BButton,
            'b-icon-arrow-up': BIconArrowUp,
            'b-icon-arrow-down': BIconArrowDown,
            'inline-svg': InlineSvg,
            'column-header': ColumnHeader,
            'b-spinner': BSpinner
        }
    })
	export default class ProjectList extends Vue {
        @Prop() refresh!: boolean
        @Prop() filter!: ProjectFilterOptions

        projects: ProjectListItem[] = [];
        listOptions: ProjectListOptions = {
            filter: this.filter,
            pagerOptions: {
                page: 1,
                pageSize: Configuration.DefaultPageSize,
                pageCount: 1,
                rowCount: 0,
                rowStart: 0,
                rowEnd: 0
            },
            sortOptions: {
                sortBy: 'name',
                sortDirection: Configuration.SortDirectionAscending
            }
        };
        isBusy = false;
        apiAccessToken = this.$store.state.apiAccessToken;
        fields: TableField[] = [];

        @Watch('refresh')
        refreshList(newVal: boolean) {
            if (newVal) {
                this.loadProjects();
            }
        }

        @Watch('filter')
        filterList(newVal: ProjectFilterOptions) {
            this.listOptions.filter = newVal;
            this.listOptions.pagerOptions.page = 1;
        }

        canEditProject(projectId: string) {
            return Authorization.checkAccessRights(this.$appUser, Authorization.operations.editProject, projectId, PermissionScope.Project);
        }

        mounted() {
            this.isBusy = false;
            this.initFields();
            this.apiAccessToken = this.$store.state.apiAccessToken;
            this.loadProjects();
            this.$root.$on('LocaleChanged', this.onLocaleChanged);
        }

        unmounted() {
            this.$root.$off('LocaleChanged');
        }

        initFields() {
            this.fields = [
                {
                    key: 'sequenceId',
                    label: this.$t('fields.id').toString(),
                    headerTitle: 'Id',
                    sortable: true,
                    thStyle: 'width: 75px',
                    thClass: 'unselectable text-nowrap columnheader',
                    tdClass: 'text-nowrap datatable-cell text-dark-75 font-size-lg font-weight-bolder py-4',
                    formatter: null
                },
                {
                    key: 'name',
                    label: this.$t('fields.name').toString(),
                    headerTitle: 'Name',
                    sortable: true,
                    thStyle: '',
                    thClass: 'unselectable text-nowrap columnheader',
                    tdClass: 'text-nowrap datatable-cell text-dark-75 font-size-lg font-weight-bolder py-4',
                    formatter: null
                },
                {
                    key: 'client',
                    label: this.$t('fields.client').toString(),
                    headerTitle: 'Client',
                    sortable: false,
                    thStyle: '',
                    thClass: 'unselectable text-nowrap columnheader',
                    tdClass: 'text-wrap datatable-cell text-dark-75 font-size-lg py-4',
                    formatter: null
                },
                {
                    key: 'projectManager',
                    label: this.$t('fields.projectManager').toString(),
                    headerTitle: 'ProjectManager',
                    sortable: false,
                    thStyle: '',
                    thClass: 'unselectable text-nowrap columnheader',
                    tdClass: 'text-wrap datatable-cell text-dark-75 font-size-lg py-4',
                    formatter: null
                },
                {
                    key: 'isActive',
                    label: this.$t('fields.status').toString(),
                    headerTitle: 'Status',
                    sortable: true,
                    thStyle: 'width: 100px',
                    thClass: 'unselectable text-nowrap columnheader',
                    tdClass: (value: boolean) => { return 'pt-5 pb-4 text-nowrap' + (value ? ' text-success' : ' text-danger'); },
                    formatter: (value: boolean) => { return value ? 'status.active' : 'status.inactive'; }
                },
                {
                    key: 'actions',
                    label: '',
                    headerTitle: '',
                    sortable: false,
                    thStyle: 'width: 125px',
                    thClass: 'columnheader',
                    tdClass: 'pl-3 pr-1 py-4 text-right',
                    formatter: null
                }
            ];
        }

        async loadProjects() {
            try {
                const response = await AxiosService.request<ServerData>({
                    url: `projectsadministration/list`,
                    method: 'POST',
                    data: this.listOptions
                });

                this.projects = response.data.records ?? [];
                this.listOptions.pagerOptions = InitPagerOptions(response.data.totalRecordCount, response.data.pageCount, this.listOptions.pagerOptions.page, this.listOptions.pagerOptions.pageSize);
            }
            catch (error) {
                if (error.response) {
                    switch (error.response.status) {
                        case 404:
                            return this.$router.push(`/${i18n.locale}/notfound`);
                        case 403:
                            return this.$router.push(`/${i18n.locale}/accessdenied`);
                        default:
                            return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                    }
                }
            }
            finally {
                this.isBusy = false;
                this.$emit('load-complete');
            }
        }

        editProject(id: string) {
             this.$emit('project-selected', id);
        }

        viewTasks(projectId: string) {
            this.$router.push({ name: 'Tasks', params: { projectId: projectId } });
        }

        async deleteProject(id: string) {
            try {
                const response = await AxiosService.request({
                    url: `projectsadministration/candelete/${id}`,
                    method: 'GET'
                });

                const canDelete = response.data.canDelete;

                const project = this.projects.find(x => x.id == id);

                if (!canDelete) {
                    this.$bvModal.msgBoxOk(
                        this.$t('modal.deniedProjectDeleteMessage', { projectName: project?.name }) as string, {
                            title: this.$t('modal.deniedProjectDeleteTitle') as string,
                            centered: true,
                            buttonSize: 'sm',
                            okTitle: this.$t('modal.closeModal') as string
                        }
                    );
                    return;
                }

                this.$bvModal.msgBoxConfirm(this.$t('modal.confirmProjectDeleteMessage', { projectName: project?.name }) as string, {
                    title: this.$t('modal.confirmProjectDeleteTitle') as string,
                        centered: true,
                        buttonSize: 'sm',
                        okTitle: this.$t('modal.confirmOkTitle') as string,
                        cancelTitle: this.$t('modal.confirmCancelTitle') as string
                    })
                    .then(value => {
                        if (value) {
                            this.isBusy = true;

                            try {
                                AxiosService.request<boolean>({
                                    url: `projectsadministration?id=${id}`,
                                    method: 'DELETE'
                                });

                                this.$root.$bvToast.toast(this.$t('toaster.projectDeleted', { projectName: project?.name }) as string, {
                                    title: this.$t('toaster.deleteProjectTitle') as string,
                                    autoHideDelay: Configuration.ToasterAutoHideDelay,
                                    appendToast: true,
                                    variant: Configuration.ToasterVariantSuccess,
                                    toaster: Configuration.ToasterPosition
                                });
                                this.$emit('project-deleted', true);
                            }
                            catch (error) {
                                if (error.response) {
                                    switch (error.response.status) {
                                        case 404:
                                            return this.$router.push(`/${i18n.locale}/notfound`);
                                        case 403:
                                            return this.$router.push(`/${i18n.locale}/accessdenied`);
                                        default:
                                            return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                                    }
                                }
                            }
                        }
                    })
                    .finally(() => {
                        this.isBusy = false;
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
            catch (error) {
                if (error.response) {
                    switch (error.response.status) {
                        case 404:
                            return this.$router.push(`/${i18n.locale}/notfound`);
                        case 403:
                            return this.$router.push(`/${i18n.locale}/accessdenied`);
                        default:
                            return this.$router.push(`/${i18n.locale}/error/${error.response.status}`);
                    }
                }
            }
            finally {
                this.isBusy = false;
            }
        }

        onChangePage(page: number) {
            this.listOptions.pagerOptions.page = page;
            this.loadProjects();
        }

        onChangePageSize(pageSize: number) {
            this.listOptions.pagerOptions.pageSize = pageSize;
            this.listOptions.pagerOptions.page = 1;
            this.loadProjects();
        }

        onSortChanged(e: TableSortEventArgs) {
            this.listOptions.sortOptions.sortBy = e.sortBy;
            this.listOptions.sortOptions.sortDirection = e.sortDesc ? -1 : 1;
            this.loadProjects();
        }

        onLocaleChanged(locale: string) { // eslint-disable-line @typescript-eslint/no-unused-vars
            this.$nextTick(() => {
                this.initFields();
            });
        }
	}

	interface ServerData {
        records: ProjectListItem[];
        totalRecordCount: number;
        pageCount: number;
	}

    interface ProjectListItem {
        id: string;
        sequenceId: number;
        name: string;
        client: EntityReference;
        projectManager: EntityReference;
        isActive: boolean;
        actions: string;
    }    

    interface ProjectListOptions {
        filter: ProjectFilterOptions;
        pagerOptions: PagerOptions;
        sortOptions: SortOptions;
    }
